import React, { Fragment, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import ConfiguracionPeriodosComponent from './ConfiguracionPeriodos/ConfiguracionPeriodosComponent'
import ConfiguracionFirmaComponent from './FirmaInspector/ConfiguracionFirmaComponent'
import { useSelector, useDispatch } from 'react-redux'

import { obtenerInspectorByIdLogin } from '../../../redux/DucksUnidadInspeccion/InspectoresDuck'
import ConfiguracionFoliosUIComponent from './ConfiguracionFolios/ConfiguracionFoliosUIComponent'

function ConfiguracionComponent(props) {

    const dispatch = useDispatch()
    const currentUser = useSelector(store => store.Usuario.data)

    const [tabUno, setTabUno] = React.useState(false)
    const [tabDos, setTabDos] = React.useState(false)
    const [tabTres, setTabTres] = React.useState(false)
    const [tabCuatro, setTabCuatro] = React.useState(false)

    const [tabPeriodos, setTabPeriodos] = React.useState(false)
    const [tabOpcion2, setTabOpcion2] = React.useState(false)
    const [tabOpcion3, setTabOpcion3] = React.useState(false)

    const [idinspector, setIdinspector] = React.useState(null)

    const setearValoresUno = () => {
        setTabUno(true); setTabDos(false); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresDos = () => {
        setTabUno(false); setTabDos(true); setTabTres(false); setTabCuatro(false);
    }
    const setearValoresTres = () => {
        setTabUno(false); setTabDos(false); setTabTres(true); setTabCuatro(false);
    }
    const setearValoresCuatro = () => {
        setTabUno(false); setTabDos(false); setTabTres(false); setTabCuatro(true);
    }
    const setearValoresPeriodos = () => {
        setTabPeriodos(true); setTabOpcion2(false); setTabOpcion3(false);
    }
    const setearValoresOpcion2 = () => {
        setTabPeriodos(false); setTabOpcion2(true); setTabOpcion3(false);
    }

    const setearValoresOpcion3 = () => {
        setTabPeriodos(false); setTabOpcion2(false); setTabOpcion3(true);
    }

    useEffect(() => {
        dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then((res) => {
            setIdinspector(res.payload.data.data.idinspector)
        })
    }, [])


    return (
        <Fragment><br />
            <div className='row text-center'>
                <div className='col-3'>
                    <button onClick={() => setearValoresUno()} className='btn btn-light'>Configuración de Unidad de Inspección</button>
                </div>
                <div className='col-3'>
                    <button onClick={() => setearValoresDos()} className='btn btn-light'>Firma Digitalizada</button>

                </div>
                <div className='col-3'>
                    <button onClick={() => setearValoresTres()} className='btn btn-light'>Administar <br></br>Folios</button>

                </div>
                <div className='col-3'>
                    <button onClick={() => setearValoresCuatro()} className='btn btn-light'>Otras <br></br>configuraciones</button>
                </div>
            </div><br />

            {
                tabUno ? (<div className='row text-center' style={{ backgroundColor: 'white' }}>
                    <br /><br />

                    <div className='col-3'>
                        <button onClick={() => setearValoresPeriodos()} className='btn btn-light'>Periodos</button>
                    </div>
                    <div className='col-3'>
                        <button onClick={() => setearValoresOpcion2()} className='btn btn-light'>Opción 2</button>

                    </div>
                    <div className='col-3'>
                        <button onClick={() => setearValoresOpcion3()} className='btn btn-light'>Opción 3</button>
                    </div>
                    <br /><br />

                    {tabPeriodos ? (<ConfiguracionPeriodosComponent handleCerrarModalConfig={props.handleCerrarModalConfig} />) : (null)}
                    <br />

                </div>) :
                    tabDos ? (<div className='row text-center' style={{ backgroundColor: 'white' }}>
                        {idinspector != null ? <ConfiguracionFirmaComponent cerrar={props.handleCerrarModalConfig} idinspector={idinspector}></ConfiguracionFirmaComponent> : <div />}
                    </div>) :
                        tabTres ? (<div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                            <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <ConfiguracionFoliosUIComponent />
                            </div>
                        </div>) :
                            tabCuatro ? (<div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                <div className='row text-center' style={{ backgroundColor: '#f8f9fa' }}>
                                    <h5>Otras configuraciones</h5>
                                </div>
                            </div>) :
                                (<></>)
            }
        </Fragment>
    );
};


export default withRouter(ConfiguracionComponent)
